import { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { SITE } from '../lib/site';
import { Icon } from './Icon';
import { LanguageSwitcher } from './LanguageSwitcher';
import { useT } from '../i18n';

export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const t = useT();

  const NAV: Array<{ to?: string; href?: string; label: string; external?: boolean; title?: string }> = [
    { to: '/how-it-works', label: t.nav.howItWorks },
    { to: '/fees', label: t.nav.fees },
    { to: '/coins', label: t.nav.coins },
    { to: '/faq', label: t.nav.faq },
    { to: '/about', label: t.nav.about },
    { href: 'https://davai.shieldmyass.xyz', label: t.nav.pepetual, external: true, title: 'perpetual trading' },
  ];

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header className={`site-header${scrolled ? ' scrolled' : ''}`}>
        <div className="container header-inner">
          <Link to="/" className="brand" aria-label={`${SITE.name} home`}>
            <img className="brand-mark" src="/logo-mark.png" alt="" aria-hidden="true" />
            <span className="brand-name">
              ShieldMyAss
            </span>
          </Link>

          <nav className="nav">
            {NAV.map((n) =>
              n.external && n.href ? (
                <a
                  key={n.href}
                  href={n.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={n.title}
                >
                  {n.label}
                </a>
              ) : (
                <NavLink
                  key={n.to}
                  to={n.to!}
                  className={({ isActive }) => (isActive ? 'active' : undefined)}
                >
                  {n.label}
                </NavLink>
              )
            )}
          </nav>

          <div className="header-actions">
            <span className="market-pill" title="Markets are live 24/7">
              <span className="mp-dot" />
              {t.nav.marketsOpen}
            </span>
            <LanguageSwitcher />
            <Link to="/contact" className="btn btn-ghost">{t.nav.support}</Link>
            <Link to="/" className="btn btn-primary">
              {t.nav.launchApp}
              <Icon name="arrow-right" width={16} height={16} />
            </Link>
            <button
              className="menu-toggle"
              aria-label="Open menu"
              aria-expanded={open}
              onClick={() => setOpen(true)}
            >
              <Icon name="menu" />
            </button>
          </div>
        </div>
      </header>

      {open && (
        <div className="nav-drawer open" role="dialog" aria-modal="true">
          <button
            className="nav-drawer-close"
            aria-label="Close menu"
            onClick={() => setOpen(false)}
          >
            <Icon name="close" />
          </button>
          <Link to="/">Home</Link>
          {NAV.map((n) =>
            n.external && n.href ? (
              <a key={n.href} href={n.href} target="_blank" rel="noopener noreferrer" title={n.title}>
                {n.label}
              </a>
            ) : (
              <Link key={n.to} to={n.to!}>
                {n.label}
              </Link>
            )
          )}
          <Link to="/contact">{t.nav.support}</Link>
        </div>
      )}
    </>
  );
}
